export default __webpack_public_path__ + "static/media/header-lg.b97b25d7.png";